"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionEditor = void 0;
const FormQuestionControllerRegistry_1 = __importDefault(require("@opsbase/lib-form/FormQuestionController/FormQuestionControllerRegistry"));
const FormQuestionType_1 = __importStar(require("@opsbase/lib-form/FormQuestionType"));
const getQuestionConfig_1 = __importDefault(require("@opsbase/lib-form/helpers/getQuestionConfig"));
const GradingMethodType_1 = __importDefault(require("@opsbase/lib-grading/GradingMethodType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const Divider_1 = __importDefault(require("@opsbase/web-layout/Divider"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Tab_1 = __importDefault(require("@opsbase/web-tabs/Tab"));
const Tabs_1 = __importDefault(require("@opsbase/web-tabs/Tabs"));
const Checkbox_1 = __importDefault(require("@opsbase/web-ui/Checkbox"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const useFedActions_1 = __importDefault(require("../FedController/useFedActions"));
const useFedDB_1 = __importDefault(require("../FedController/useFedDB"));
const useFedSelect_1 = __importDefault(require("../FedController/useFedSelect"));
const useFedSetup_1 = __importDefault(require("../FedController/useFedSetup"));
const getQuestionAncestors_1 = require("../helpers/getQuestionAncestors");
const QuestionEditorAttachments_1 = __importDefault(require("./QuestionEditorAttachments"));
const QuestionEditorRichText_1 = __importDefault(require("./QuestionEditorRichText"));
const T = __importStar(require("./types"));
// eslint-disable-next-line no-shadow
var TabLabel;
(function (TabLabel) {
    TabLabel["ANSWERS"] = "answers";
    TabLabel["INFORMATION"] = "information";
    TabLabel["ATTACHMENTS"] = "attachments";
    TabLabel["SETTINGS"] = "settings";
    TabLabel["ISSUE_SETTINGS"] = "issue-settings";
})(TabLabel || (TabLabel = {}));
function labelForTabLabel(v) {
    switch (v) {
        case TabLabel.ANSWERS:
            return lib_i18n_1.default.t('answers');
        case TabLabel.INFORMATION:
            return lib_i18n_1.default.t('information');
        case TabLabel.ATTACHMENTS:
            return lib_i18n_1.default.t('attachments');
        case TabLabel.SETTINGS:
            return lib_i18n_1.default.t('settings');
        case TabLabel.ISSUE_SETTINGS:
            return lib_i18n_1.default.t('issue-settings');
    }
}
const questionTypes = {
    [FormQuestionType_1.default.CHECK]: [
        T.QuestionEditorCheck,
        [TabLabel.ANSWERS, TabLabel.INFORMATION, TabLabel.ATTACHMENTS],
    ],
    [FormQuestionType_1.default.LIST]: [
        T.QuestionEditorList,
        [TabLabel.ANSWERS, TabLabel.INFORMATION, TabLabel.ATTACHMENTS],
    ],
    [FormQuestionType_1.default.NUMBER]: [
        T.QuestionEditorNumber,
        [TabLabel.SETTINGS, TabLabel.INFORMATION, TabLabel.ATTACHMENTS],
    ],
    [FormQuestionType_1.default.RATING]: [
        T.QuestionEditorRating,
        [TabLabel.ANSWERS, TabLabel.INFORMATION, TabLabel.ATTACHMENTS],
    ],
    [FormQuestionType_1.default.INFO]: [
        T.QuestionEditorInfo,
        [undefined, TabLabel.INFORMATION, TabLabel.ATTACHMENTS],
    ],
    [FormQuestionType_1.default.TEXT]: [
        T.QuestionEditorText,
        [TabLabel.SETTINGS, TabLabel.INFORMATION, TabLabel.ATTACHMENTS],
    ],
    [FormQuestionType_1.default.DATETIME]: [
        T.QuestionEditorDatetime,
        [TabLabel.SETTINGS, TabLabel.INFORMATION, TabLabel.ATTACHMENTS],
    ],
    [FormQuestionType_1.default.REPETITION]: [
        T.QuestionEditorRepetition,
        [TabLabel.SETTINGS, TabLabel.INFORMATION, TabLabel.ATTACHMENTS],
    ],
    [FormQuestionType_1.default.PHOTO]: [
        T.QuestionEditorPhoto,
        [TabLabel.SETTINGS, TabLabel.INFORMATION, TabLabel.ATTACHMENTS],
    ],
    [FormQuestionType_1.default.ISSUE]: [
        T.QuestionEditorIssue,
        [TabLabel.ISSUE_SETTINGS, TabLabel.INFORMATION, TabLabel.ATTACHMENTS],
    ],
    [FormQuestionType_1.default.SIGNATURE]: [
        T.QuestionEditorSignature,
        [undefined, TabLabel.INFORMATION, TabLabel.ATTACHMENTS],
    ],
    [FormQuestionType_1.default.SPT]: [
        T.QuestionEditorSPT,
        [TabLabel.SETTINGS, TabLabel.INFORMATION, TabLabel.ATTACHMENTS],
    ],
    [FormQuestionType_1.default.ASSET]: [
        T.QuestionEditorAsset,
        [TabLabel.SETTINGS, TabLabel.INFORMATION, TabLabel.ATTACHMENTS],
    ],
    [FormQuestionType_1.default.QUESTIONSET]: [T.QuestionEditorQuestionSet, []],
    [FormQuestionType_1.default.SECTION]: [
        T.QuestionEditorSection,
        [undefined, TabLabel.INFORMATION, TabLabel.ATTACHMENTS],
    ],
};
function QuestionEditor() {
    const db = (0, useFedDB_1.default)();
    const { fullySelected } = (0, useFedSelect_1.default)();
    const { isScoreEnabled, gradingMethod, canAllQuestionsBeSkipped } = (0, useFedSetup_1.default)();
    const { doChangeQuestionConfig } = (0, useFedActions_1.default)();
    const question = fullySelected ? db.questions[fullySelected] : undefined;
    const currentQId = (0, react_1.useRef)();
    const [selectedTab, setSelectedTab] = (0, react_1.useState)(0);
    const { qId, type: qType, config: qConfig } = question !== null && question !== void 0 ? question : {};
    const handleChangeConfig = (0, react_1.useCallback)((configForType) => doChangeQuestionConfig(qId, configForType), [doChangeQuestionConfig, qId]);
    const config = (0, react_1.useMemo)(() => {
        const c = qConfig === null || qConfig === void 0 ? void 0 : qConfig[qType];
        if (!c) {
            return qType ? FormQuestionControllerRegistry_1.default[qType].createConfig() : null;
        }
        return c;
    }, [qConfig, qType]);
    (0, react_1.useEffect)(() => {
        if (!question || question.qId === currentQId.current)
            return;
        currentQId.current = question.qId;
        const questionType = questionTypes[question.type];
        const defaultTab = !!questionType[1][0] ? 0 : 1;
        setSelectedTab(defaultTab);
    }, [question]);
    const handleChangeSelectedTab = (0, react_1.useCallback)((_, v) => {
        setSelectedTab(v);
    }, []);
    const handleChangeIgnoreScoring = (0, react_1.useCallback)(scoring => {
        const cfg = (0, getQuestionConfig_1.default)(question.type, question);
        cfg.scoring = !scoring;
        handleChangeConfig(cfg);
    }, [handleChangeConfig, question]);
    const handleChangeEnableNA = (0, react_1.useCallback)(enableNA => {
        const cfg = question.config[question.type];
        cfg.enableNA = enableNA;
        handleChangeConfig(cfg);
    }, [handleChangeConfig, question]);
    return (0, react_1.useMemo)(() => {
        if (!question)
            return null;
        const ancestors = (0, getQuestionAncestors_1.getQuestionAncestors)(db, question);
        const isAQSet = !!(question === null || question === void 0 ? void 0 : question.parentQSetId);
        const isInAQSet = ancestors === null || ancestors === void 0 ? void 0 : ancestors.some(a => !!(a === null || a === void 0 ? void 0 : a.parentQSetId));
        const isInASkippedSectiond = ancestors.some(a => a.type === FormQuestionType_1.default.SECTION && a.config[FormQuestionType_1.default.SECTION].enableNA);
        const questionType = questionTypes[question.type];
        const questionController = FormQuestionControllerRegistry_1.default[question.type];
        const canEnableNA = questionController.canEnableNA();
        const canScore = questionController.canScore();
        const TypeForm = questionType[0];
        const tabs = questionType[1];
        const qqId = question.qId;
        let tabToSelect = selectedTab;
        const noOfTabs = tabs.filter(t => !!t).length;
        if (!tabs[tabToSelect])
            tabToSelect = 1;
        if (!tabs[tabToSelect])
            tabToSelect = 2;
        if (!tabs[tabToSelect])
            tabToSelect = -1;
        return (react_1.default.createElement(Vertical_1.default, null,
            react_1.default.createElement(Pane_1.default, { padding: true },
                react_1.default.createElement(Text_1.default, { variant: "h1" }, (0, FormQuestionType_1.questionTypeTitle)(question.type))),
            react_1.default.createElement(Pane_1.default, { padding: true },
                react_1.default.createElement(Text_1.default, { variant: "h3" }, (0, FormQuestionType_1.questionTypeDesc)(question.type))),
            react_1.default.createElement(Divider_1.default, null),
            noOfTabs > 1 && (react_1.default.createElement(Pane_1.default, { paddingX: true },
                react_1.default.createElement(Tabs_1.default, { indicatorColor: "primary", value: tabToSelect, onChange: handleChangeSelectedTab },
                    tabs[0] && react_1.default.createElement(Tab_1.default, { label: labelForTabLabel(tabs[0]), value: 0 }),
                    tabs[1] && react_1.default.createElement(Tab_1.default, { label: labelForTabLabel(tabs[1]), value: 1 }),
                    tabs[2] && react_1.default.createElement(Tab_1.default, { label: labelForTabLabel(tabs[2]), value: 2 })))),
            noOfTabs > 1 && react_1.default.createElement(Divider_1.default, null),
            react_1.default.createElement(Pane_1.default, { grow: true, scrollY: true, style: {
                    borderBottom: `1px solid ${lib_palette_1.default.BorderGrey.main}`,
                    margin: '0 8px',
                    paddingTop: 16,
                } },
                selectedTab === 0 && (react_1.default.createElement(TypeForm, { key: 'typeFor' + qqId, qId: qqId, qTitle: question.title, config: config, onChange: handleChangeConfig, scoring: isScoreEnabled && (config === null || config === void 0 ? void 0 : config.scoring), disabled: isAQSet || isInAQSet, immediateFailAvailable: (gradingMethod === null || gradingMethod === void 0 ? void 0 : gradingMethod.gradingMethodType) !== GradingMethodType_1.default.NONE })),
                selectedTab === 1 && (react_1.default.createElement(QuestionEditorRichText_1.default, { disabled: isAQSet || isInAQSet, key: 'infoFor' + qqId, config: config, onChange: handleChangeConfig })),
                selectedTab === 2 && (react_1.default.createElement(QuestionEditorAttachments_1.default, { disabled: isAQSet || isInAQSet, key: 'filesFor' + qqId, config: config, onChange: handleChangeConfig }))),
            canEnableNA && (react_1.default.createElement(Pane_1.default, { padding: true },
                react_1.default.createElement(Checkbox_1.default, { disabled: canAllQuestionsBeSkipped ||
                        isAQSet ||
                        isInAQSet ||
                        isInASkippedSectiond, checked: config === null || config === void 0 ? void 0 : config.enableNA, color: lib_palette_1.default.GoodOldBlue, onChange: handleChangeEnableNA, label: lib_i18n_1.default.t('enable-not-applicable') }))),
            isScoreEnabled && canScore && (react_1.default.createElement(Pane_1.default, { padding: true },
                react_1.default.createElement(Checkbox_1.default, { disabled: isAQSet || isInAQSet, checked: !(config === null || config === void 0 ? void 0 : config.scoring), color: lib_palette_1.default.secondary, onChange: handleChangeIgnoreScoring, label: lib_i18n_1.default.t('ignore-scoring') })))));
    }, [
        question,
        db,
        selectedTab,
        handleChangeSelectedTab,
        config,
        handleChangeConfig,
        isScoreEnabled,
        gradingMethod === null || gradingMethod === void 0 ? void 0 : gradingMethod.gradingMethodType,
        canAllQuestionsBeSkipped,
        handleChangeEnableNA,
        handleChangeIgnoreScoring,
    ]);
}
exports.QuestionEditor = QuestionEditor;
exports.default = QuestionEditor;
